import { getUserCountry } from "../../../utils/ALL/localStorageUtils";
import NZMasterTxnDetailViewContainer from "./NZ/NZMasterTxnDetailViewContainer";
import "./MasterTransactionDetails.css";
import AUMasterTxnDetailViewContainer from "./AU/AUMasterTxnDetailViewContainer";
import { COUNTRY_AU, COUNTRY_NZ } from "../../../utils/ALL/tenantUtils";
const MasterTxnDetailsViewHandler = () => {
  const tenantCountry = getUserCountry().toUpperCase();
  if (tenantCountry === COUNTRY_AU) {
    return <AUMasterTxnDetailViewContainer></AUMasterTxnDetailViewContainer>;
  } else if (tenantCountry === COUNTRY_NZ) {
    return <NZMasterTxnDetailViewContainer></NZMasterTxnDetailViewContainer>;
  } else {
    return null;
  }
};

export default MasterTxnDetailsViewHandler;
